// Carrosel de anúncios relacionados
(function () {
  "use strict";

  $(".carrosel-anuncios").slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 3000,
    responsive: [
      {
        breakpoint: 1199,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 760,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  });
})();

// Campo star
$(".star-rating-input i").on("click", function () {
  $(".star-rating-input i").removeClass("checked active");
  $(this).addClass("checked active");
  $("#avaliacao-input").val($(this).data("value"));
  for (var i = 1; i <= $(this).data("value"); i++) {
    $('.star-rating-input i[data-value="' + i + '"]').addClass("active");
  }
  // Valida o formulário
  $("#avaliacao-input").parsley().validate();
});

// Envia avaliação
var enviando_formulario = false;
$("#form-avaliacao").on("submit", function (e) {
  e.preventDefault();

  var obj = this;
  var form = $(obj);
  var submit_btn = form.find("#enviar_avaliacao");
  var submit_btn_text = submit_btn.text();
  var dados = new FormData(obj);

  function volta_submit() {
    submit_btn.attr("disabled", false);
    submit_btn.text(submit_btn_text);
    enviando_formulario = false;
    hideLoading();
  }

  if (!enviando_formulario) {
    $.ajax({
      url: form.attr("action"),
      type: form.attr("method"),
      data: dados,
      processData: false,
      cache: false,
      contentType: false,
      beforeSend: function () {
        showLoading();
        enviando_formulario = true;
        submit_btn.attr("disabled", true);
        submit_btn.text("Enviando...");
      },
      success: function (data) {
        //console.log(data);
        volta_submit();
        if (data == "ok") {
          closeModal("modal-avaliacao");
          //$("#form-avaliacao .campo").val("");
          showAlert(
            "Sucesso",
            "Obrigado! Sua avaliação foi enviada com sucesso.",
            "success"
          );
        } else {
          showAlert("Erro", "Não foi possível enviar a mensagem.", "error");
        }
      },
      error: function (xhr, type, exception) {
        volta_submit();
        showAlert("Erro", "Não foi possível enviar a mensagem.", "error");
        console.log("ajax error response type " + type);
      },
    });
  }
});
